import { Component, OnInit, inject } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Page} from '../../../core/pagination/page';
import {PageRequest} from '../../../core/pagination/page-request';
import {SortOrder} from '../../../core/sort/sort-order';
import {Thuisverzorger} from '../../../thuisverzorger/thuisverzorger';
import {ThuisverzorgerService} from '../../../thuisverzorger/thuisverzorger.service';
import {Router} from '@angular/router';
import {Zone} from 'src/app/zone/zone';
import {ZoneService} from '../../../zone/zone.service';
import {DienstService} from '../../../dienst/dienst.service';
import {DialogService} from '../../../core/dialog/dialog.service';
import {filter, mergeMap, tap} from 'rxjs/operators';
import {Diensten} from '../../../dienst/diensten';

@Component({
    templateUrl: './thuisverzorgers.page.html',
    styleUrls: ['./thuisverzorgers.page.scss'],
    standalone: false
})
export class ThuisverzorgersPage implements OnInit {
  private thuisverzorgerService = inject(ThuisverzorgerService);
  private zoneService = inject(ZoneService);
  private dienstService = inject(DienstService);
  private dialogService = inject(DialogService);
  private router = inject(Router);

  initialPageRequest: PageRequest<Thuisverzorger> = PageRequest.firstPageRequest<Thuisverzorger>(SortOrder.ASCENDING, 5);
  thuisverzorgersPage$: Subject<Page<Thuisverzorger>> = new Subject<Page<Thuisverzorger>>();
  zones$: Observable<Array<Zone>>;
  diensten$: Observable<Diensten>;
  private currentPageRequest: PageRequest<Thuisverzorger>;

  ngOnInit(): void {
    this.getThuisverzorgers$(this.initialPageRequest).subscribe();
    this.zones$ = this.zoneService.getZones$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  navigateToThuisverzorger(thuisverzorger: Thuisverzorger): void {
    this.router.navigateByUrl(`/thuisverzorgers/${thuisverzorger.getId()}`);
  }

  deleteThuisverzorger(thuisverzorger: Thuisverzorger): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${thuisverzorger.getVoornaam()} wil verwijderen?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.thuisverzorgerService.deleteThuisverzorger$(thuisverzorger.getId())),
        mergeMap(() => this.getThuisverzorgers$(this.currentPageRequest.toFirstPage())),
      )
      .subscribe();
  }

  navigateToAddThuisverzorger(): void {
    this.router.navigateByUrl('/thuisverzorgers/toevoegen');
  }

  onPageChange(pageRequest: PageRequest<Thuisverzorger>): void {
    this.getThuisverzorgers$(pageRequest).subscribe();
  }

  private getThuisverzorgers$(pageRequest: PageRequest<Thuisverzorger>): Observable<Page<Thuisverzorger>> {
    this.currentPageRequest = pageRequest;
    return this.thuisverzorgerService
      .getThuisverzorgersPage$(pageRequest)
      .pipe(tap(page => this.thuisverzorgersPage$.next(page)));
  }
}
